"use strict";

exports.__esModule = true;
exports.default = createStoreHistory;

var _Actions = _interopRequireDefault(require("./Actions"));

var _maybePromisify = _interopRequireDefault(require("./utils/maybePromisify"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createStoreHistory(store, getLocation) {
  if (getLocation === void 0) {
    getLocation = function getLocation(_ref) {
      var location = _ref.location;
      return location;
    };
  }

  return {
    listen: function listen(listener) {
      var location = getLocation(store.getState());
      listener(location);
      return store.subscribe(function () {
        var nextLocation = getLocation(store.getState());

        if (nextLocation !== location) {
          listener(nextLocation);
          location = nextLocation;
        }
      });
    },
    listenBefore: function listenBefore(hook) {
      return store.farce.addTransitionHook((0, _maybePromisify.default)(hook, 1));
    },
    push: function push(location) {
      store.dispatch(_Actions.default.push(location));
    },
    replace: function replace(location) {
      store.dispatch(_Actions.default.replace(location));
    },
    goBack: function goBack() {
      store.dispatch(_Actions.default.go(-1));
    },
    goForward: function goForward() {
      store.dispatch(_Actions.default.go(1));
    },
    go: function go(delta) {
      store.dispatch(_Actions.default.go(delta));
    },
    createHref: function createHref(location) {
      return store.farce.createHref(location);
    },
    createLocation: function createLocation(location) {
      return store.farce.createLocation(location);
    },
    dispose: function dispose() {
      store.dispatch(_Actions.default.dispose());
    },
    // For compatibility with React Router v2.x.
    __v2_compatible__: true
  };
}

module.exports = exports.default;